"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
query seasonFees($seasonId: String!) {
    seasonFees(seasonId: $seasonId) {
      _id
      name
      orgId
      seasonId
      eventId
      type
      value
      appliedTo
      appliedBy
      minAppliedToPrice
      maxAppliedToPrice
      filters
      createdBy
      createdAt
      updatedBy
      updatedAt
      paymentMethods
      disabled
      __typename
    }
  }`;
exports.default = query;
//# sourceMappingURL=seasonFees.query.js.map